// frontend/src/pages/ManageArtistsPage.js
import React, { useContext, useEffect, useState } from 'react';
import { FaUser, FaTimes, FaArrowLeft, FaSearch } from 'react-icons/fa';
import { DataContext } from "../context/DataContext";
import { get_new_artist_ids_hint_api, create_artist_by_admin_api, BASE_URL } from '../controllers/dataController';
import PlatformWiseArtistsData from '../components/PlatformWiseArtistsData';
import EditArtistForm from '../components/EditArtistForm';
import Header from '../components/Header';
import {Button} from '../components/custom_ui/button.tsx';
import { Link } from 'react-router-dom';
import SearchableSelect from '../components/SearchableSelect';
import { useAlert } from '../context/AlertContext';

const ManageArtistsPage = () => {
    const { applicationData, getUniqueArtistsData } = useContext(DataContext);
    const { showAlert } = useAlert();
    const [showAddArtistForm, setShowAddArtistForm] = useState(false);
    const [showEditArtistForm, setShowEditArtistForm] = useState(false);
    const [newArtistForm, setNewArtistForm] = useState({});
    const [newArtistName, setNewArtistName] = useState("");
    const [newArtistIdHints, setNewArtistIdHints] = useState({});
    const [customArtistId, setCustomArtistId] = useState([]);

    // State for PlatformWiseArtistsData
    const [platformSearchTerm, setPlatformSearchTerm] = useState("");
    const [platformSearchFilter, setPlatformSearchFilter] = useState("artist_id");

    const searchArtistId = (id) => {
        setPlatformSearchFilter("artist_id");
        setPlatformSearchTerm(id);
    };

    useEffect(() => {
        getUniqueArtistsData(); // Fetch artists data on mount if not already loaded
    }, []);

    useEffect(() => {
        console.log("newArtistName changed:", newArtistName);
        setNewArtistForm(prevForm => ({
            ...prevForm,
            name: newArtistName
        }));

        if(newArtistName.length > 2){
            get_new_artist_ids_hint_api(newArtistName).then((response) => {
                console.log("hints received:", response);
                setNewArtistIdHints(response.new_artist_ids);
            }).catch((error) => {
                console.error("Failed to get hints:", error);
            });
        }
    }, [newArtistName]);

    const handleCustomId = () => {
        setCustomArtistId([...customArtistId, ""]);
    }

    const handleCustomIdChange = (index, value) => {
        const updatedIds = [...customArtistId];
        updatedIds[index] = value;
        setCustomArtistId(updatedIds);
    }

    const handleRemoveCustomId = (index) => {
        const updatedIds = [...customArtistId];
        updatedIds.splice(index, 1);
        setCustomArtistId(updatedIds);
    }

    const handleCreateArtist = (e) => {
        e.preventDefault();
        const { email, password } = newArtistForm;
        
        if (!newArtistName || newArtistName.trim() === "") {
            showAlert("Artist/Label Name is required.", "danger");
            return;
        }

        if (!email || !email.trim()) {
            showAlert("Email is required.", "danger");
            return;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            showAlert("Email is invalid.", "danger");
            return;
        }

        if (!password || !password.trim()) {
            showAlert("Password is required.", "danger");
            return;
        } else if (password.trim().length < 6) {
            showAlert("Password must be at least 6 characters.", "danger");
            return;
        }

        const hasSelectedIds = newArtistForm.artist_ids && newArtistForm.artist_ids.length > 0;
        const hasCustomIds = customArtistId.length > 0;

        if (!hasSelectedIds && !hasCustomIds) {
            showAlert("Please select at least one artist ID or add a custom ID.", "danger");
            return;
        }

        console.log("Creating artist with data:", newArtistForm);
        newArtistForm.artist_ids = newArtistForm.artist_ids ? newArtistForm.artist_ids.concat(customArtistId) : customArtistId;
        
        create_artist_by_admin_api(newArtistForm).then((response) => {
            console.log("Artist created successfully:", response);
            showAlert("Artist created successfully!", "success");
            setShowAddArtistForm(false);
            setNewArtistForm({});
            setNewArtistName("");
            setNewArtistIdHints([]);
            setCustomArtistId([]);
            getUniqueArtistsData(); // Refresh list if needed
        }).catch((error) => {
            console.error("Failed to create artist:", error);
            showAlert(error.toString(), "danger");
        });
    }

    return (
        <div className="bg-background min-h-screen">
            <div className='absolute top-0 left-0 right-0 '>
                <Header />
            </div>
            <div className="text-white pt-28 py-6 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="flex items-center mb-6">
                        <Link to="/admin_dashboard" className="text-muted-foreground hover:text-primary mr-4">
                            <FaArrowLeft size={20} />
                        </Link>
                        <h1 className="text-2xl font-bold flex items-center">
                            Manage Artists
                        </h1>
                    </div>
                    <div className="bg-gradient-card border border-border/50 rounded-md p-4 mt-8">
                        <h3 className="text-lg font-semibold mb-4">
                            <FaUser className="inline-block mr-2 text-green-500" />Create/Manage Artists
                        </h3>
                        <div className='flex flex-col md:flex-row gap-4'>
                            <Button
                                className="w-full text-white font-bold py-3 px-4 rounded-md"
                                type="submit"
                                onClick={() => {setShowAddArtistForm(true); setShowEditArtistForm(false);}}
                            >
                                Add New Artist
                            </Button>
                            <Button
                                className="w-full text-white font-bold py-3 px-4 rounded-md"
                                type="submit"
                                onClick={() => {setShowEditArtistForm(true); setShowAddArtistForm(false);}}
                            >
                                Edit Already Existing Artist
                            </Button>
                        </div>
                        <div className='flex flex-col justify-center items-center'>
                            {showAddArtistForm ?
                                <div className="mt-4 p-4 w-3/4 rounded-md flex flex-col items-center">
                                    <div className="flex justify-between items-center w-100 mb-2"> {/* Added flex container */}
                                        <h4 className="text-md font-semibold">Add New Account</h4>
                                        <button onClick={() => setShowAddArtistForm(false)} className="text-gray-400 hover:text-white p-1 rounded-full hover:bg-gray-600">
                                            <FaTimes />
                                        </button>
                                    </div>
                                    <form>
                                        <div className="mb-4 w-100">
                                            <div>
                                                <label className="block text-gray-400 text-sm mb-2" htmlFor="artistName">Artist/Label Name</label>
                                                <input
                                                    className="w-full bg-[#2A2A40] border border-gray-600 text-white rounded-md py-2 px-3 focus:outline-none focus:border-purple-500"
                                                    id="artistName"
                                                    value={newArtistName}
                                                    onChange={(e) => setNewArtistName(e.target.value)}
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <label className="block text-gray-400 text-sm mb-2" htmlFor="artistEmail">Artist/Label Email</label>
                                                <input
                                                    className="w-full bg-[#2A2A40] border border-gray-600 text-white rounded-md py-2 px-3 focus:outline-none focus:border-purple-500"
                                                    id="artistEmail"
                                                    value={newArtistForm.email || ''}
                                                    onChange={(e) => setNewArtistForm({ ...newArtistForm, email: e.target.value })}
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <label className="block text-gray-400 text-sm mb-2" htmlFor="artistPassword">Account Password</label>
                                                <input
                                                    className="w-full bg-[#2A2A40] border border-gray-600 text-white rounded-md py-2 px-3 focus:outline-none focus:border-purple-500"
                                                    id="artistPassword"
                                                    value={newArtistForm.password || ''}
                                                    onChange={(e) => setNewArtistForm({ ...newArtistForm, password: e.target.value })}
                                                />
                                            </div>
                                            <div className="mt-4">
                                                <label className="block text-gray-400 text-sm mb-2" htmlFor="artistPlatformsIds">Add Artist Platforms Ids</label>
                                                <div className='flex flex-col gap-3'>
                                                    {Object.keys(newArtistIdHints).length > 0 ? (
                                                        <SearchableSelect
                                                            options={Object.keys(newArtistIdHints)
                                                                .filter(id => !newArtistForm.artist_ids?.includes(id))
                                                                .map(id => ({ value: id, label: id }))
                                                            }
                                                            placeholder="Select from hinted IDs..."
                                                            renderOption={(option) => (
                                                                <div className="flex items-center justify-between w-full group">
                                                                    <div>
                                                                        <button 
                                                                            type="button"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                searchArtistId(option.value);
                                                                            }}
                                                                            className="mr-2 text-white hover:text-white p-1 rounded-full hover:bg-white/10 opacity-50 group-hover:opacity-100 transition-opacity"
                                                                            title="Search this ID"
                                                                        >
                                                                            <FaSearch size={12} />
                                                                        </button>
                                                                    <span>{option.label}</span>
                                                                    </div>
                                                                    <div className="flex items-center gap-2 ml-2">
                                                                        <div className="flex gap-1">
                                                                            {newArtistIdHints[option.value] && newArtistIdHints[option.value].map((platform, i) => (
                                                                                <img 
                                                                                    key={i} 
                                                                                    src={`${BASE_URL}/icons/${platform}/`} 
                                                                                    alt={platform}
                                                                                    className="w-5 h-5 rounded-full object-cover bg-white" 
                                                                                    title={platform}
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                        
                                                                    </div>
                                                                </div>
                                                            )}
                                                            onChange={(selectedId) => {
                                                                setNewArtistForm((prevForm) => {
                                                                    let updatedArtistIds = prevForm.artist_ids ? [...prevForm.artist_ids] : [];
                                                                    if (!updatedArtistIds.includes(selectedId)) {
                                                                        updatedArtistIds.push(selectedId);
                                                                    }
                                                                    return { ...prevForm, artist_ids: updatedArtistIds };
                                                                });
                                                            }}
                                                        />
                                                    ) : (
                                                        <p className="text-gray-400 text-xs italic">Type artist name to see hinted IDs</p>
                                                    )}

                                                    {/* Selected IDs from Hints */}
                                                    <div className="flex flex-wrap gap-2">
                                                        {newArtistForm.artist_ids && newArtistForm.artist_ids.map((id) => (
                                                            <div key={id} className="flex items-center bg-[#2A2A40] border border-border/50 rounded-full px-3 py-1 text-xs">
                                                                <span className="mr-2 font-medium">{id}</span>
                                                                <div className="flex mr-2">
                                                                    {newArtistIdHints[id] && newArtistIdHints[id].map((platform, pIndex) => (
                                                                        <img 
                                                                            key={pIndex} 
                                                                            src={BASE_URL +"/icons/"+platform+"/"} 
                                                                            alt={platform} 
                                                                            className="w-4 h-4 rounded-full -ml-1 border border-background"
                                                                        />
                                                                    ))}
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setNewArtistForm(prev => ({
                                                                            ...prev,
                                                                            artist_ids: prev.artist_ids.filter(item => item !== id)
                                                                        }));
                                                                    }}
                                                                    className="text-muted-foreground hover:text-destructive transition-colors"
                                                                >
                                                                    <FaTimes size={10} />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className="space-y-2 mt-2">
                                                        {customArtistId.map((id, index) => (
                                                            <div key={index} className="flex items-center gap-2">
                                                                <input
                                                                    type="text"
                                                                    className="flex-1 bg-[#2A2A40] border border-gray-600 text-white rounded-md py-2 px-3 focus:outline-none focus:border-primary text-sm"
                                                                    placeholder="Enter custom artist ID"
                                                                    value={id}
                                                                    onChange={(e) => handleCustomIdChange(index, e.target.value)}
                                                                />
                                                                <button 
                                                                    className='p-2 text-red-500 hover:bg-red-500/10 rounded-md transition-colors' 
                                                                    type='button' 
                                                                    onClick={() => handleRemoveCustomId(index)}
                                                                >
                                                                    <FaTimes />
                                                                </button>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <button 
                                                        type='button' 
                                                        onClick={handleCustomId}
                                                        className="text-xs text-primary hover:underline w-fit font-medium"
                                                    >
                                                        + Add Custom ID
                                                    </button>
                                                    
                                                    <Button
                                                        className="mt-4 w-full text-white font-bold py-2.5 px-4 rounded-md shadow-gold hover:shadow-gold/60 transition-all active:scale-[0.98]"
                                                        onClick={handleCreateArtist}
                                                    >
                                                        Create Account
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div> : ""}
                            {showEditArtistForm ? <EditArtistForm setShowEditArtistForm={setShowEditArtistForm} searchArtistId={searchArtistId} /> : ""}
                        </div>
                    </div>
                    <PlatformWiseArtistsData 
                        searchTerm={platformSearchTerm}
                        setSearchTerm={setPlatformSearchTerm}
                        searchFilter={platformSearchFilter}
                        setSearchFilter={setPlatformSearchFilter}
                    />
                </div>
            </div>
        </div>
    );
};

export default ManageArtistsPage;